import React from 'react'
import moment from 'moment'
import {translateProductState} from 'lib/strings'
import Heading from 'components/shared/Heading'
import RateProductDelivery from 'components/shared/RateProductDelivery'
import './index.scss'

const EXPRESS_SLA_IN_HOURS = 20

function createSLA(date, express = false) {
  if (!date) return null

  const slaDate = moment(date)
  if (express) {
    slaDate.hour(EXPRESS_SLA_IN_HOURS)
  }
  else {
    slaDate.add(1, 'days').hour(12) // eslint-disable-line no-magic-numbers
  }

  return slaDate.set({minute: 0, second: 0})
}

const ProductHeading = ({product, canRateProductDelivery}) => {
  const isDelivered = product.state === 'delivered' || product.state === 'awaiting_approval'

  const fields = []
  if (product.createdAt) {
    fields.push({label: 'Bestilt dato', value: moment(product.createdAt).format('DD. MMMM YYYY')})
  }

  if (!isDelivered) {
    fields.push({label: 'Status', value: translateProductState(product)})
  }
  else {
    if (product.deliveredAt) {
      fields.push({label: 'Levert', value: moment(product.deliveredAt).format('DD. MMMM YYYY, HH:mm')})
    }
    if (product.booking) {
      fields.push({label: 'Ressurs', value: product.booking.resourceName})
    }
  }

  if (product.state === 'booked' && product.booking) {
    fields.push({label: 'Booket ressurs', value: product.booking.resourceName})
    if (product.booking.startsAt) {
      fields.push({label: 'Booket tid', value: moment(product.booking.startsAt).format('DD. MMMM YYYY, HH:mm')})
    }
  }

  const sla = product.booking
    ? createSLA(product.booking.endsAt, product.order ? product.order.expressDelivery : false)
    : null

  if (sla) {
    fields.push({
      label: 'Forventet lev',
      value: sla.format('DD. MMMM YYYY, HH:mm')
    })
  }

  if (isDelivered && canRateProductDelivery) {
    fields.push({
      label: <span className="rating">Hva synes du om bildene?</span>,
      value: <RateProductDelivery product={product} />
    })
  }

  return (
    <div className="product-heading">
      <Heading level={2}>{product.name}</Heading>
      <div className="fields">
        {fields.map((field, i) => (
          <span key={i}>
            <span>{field.label}:</span>
            {field.value}
          </span>
        ))}
      </div>
    </div>
  )
}

export default ProductHeading
